import React, { PureComponent } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Link        from '../../components/link';
import LOGO        from './images/logo.png';
import logo_nhn    from './images/company/Company_logo_1.png';
import logo_nico   from './images/company/Company_logo_2.png';
import logo_pretia from './images/company/Company_logo_3.png';


const Section = styled.div`
  background: #181818;
  margin-top: 6em;
  padding: 4em 1em 6em;
  position: relative;

  @media (max-width: 767px) {
    z-index: 4;
  }

  a {
    text-decoration: none;
  }
`;

const Nav = styled.div`
  align-items: center;
  display: grid;
  font-size: 0.9em;
  grid-gap: 0.75em 1em;
  grid-template-columns: 0.9fr 1fr;
  grid-template-rows: auto auto;

  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;

const NavItem = styled.p`
  margin: 0;
  transition: color 0.2s ease-out;
  color: ${props => props.theme.primary};

  &:nth-child(odd) { text-align: right; }

  @media (min-width: 768px) {
    text-align: left;

    &:not(:first-child) {
      margin-left: 1.5em;
    }
  }
`;

const NavItemC = styled.p`
  font-size: 0.8em;

  margin: 0;
  transition: color 0.2s ease-out;
  color: #919191;

  &:nth-child(odd) { text-align: right; }

  @media (min-width: 768px) {
    text-align: left;

    &:not(:first-child) {
      margin-left: 1.5em;
    }
  }
`;

const Logo = styled.img`
  display: block;
  height: 6em;
  margin: 1em auto 0;
`;

const Copyright = styled.div`
  color: #b8b8b8;
  margin-top: 1em;
  text-align: center;

  > small {
    display: block;

    &:not(:first-of-type) {
      margin-top: 0.25em;
    }
  }
`;

class Footer extends PureComponent {
  render() {
    return (
      <Section>

        {/* 免責事項など */}
        <Nav>
          <NavItem>
            <Link to="/games/6/disclaimer/"> <Translate id="cmpLandingPage.footer.disclaimer" /> </Link>
          </NavItem>
          <NavItem>
            <Link to="/privacy-policy/"> <Translate id="cmpLandingPage.footer.policy" /> </Link>
          </NavItem>
          <NavItem>
            <Link to="/sales-notice/"> <Translate id="cmpLandingPage.footer.salesNotice" /> </Link>
          </NavItem>
          <NavItem>
            <Link to="/contact/"> <Translate id="cmpLandingPage.footer.contact" /> </Link>
          </NavItem>
        </Nav>

        {/* 会社クレジット */}
        <Nav style={{margin: '5em 0 2em 0'}}>
          <NavItem><img src={logo_nhn}    style={{width: '6em'}} /></NavItem>
          <NavItem><img src={logo_nico}   style={{width: '6em'}} /></NavItem>
          <NavItem><img src={logo_pretia} style={{width: '6em'}} /></NavItem>
        </Nav>

        {/* コピーライト */}
        <Nav>
          <NavItemC><Translate id="cmpLandingPage.footer.copyright.nhn"  /></NavItemC>
          <NavItemC><Translate id="cmpLandingPage.footer.copyright.nico" /></NavItemC>
        </Nav>
        <Nav>
          <NavItemC><Translate id="cmpLandingPage.footer.copyright.pretia" /></NavItemC>
        </Nav>

        {/* ロゴ */}
        <Logo alt="Logo" src={LOGO} />

      </Section>
    );
  }
}

export default Footer;
